define([
	"dojo/_base/declare",
	"underscore",
	"csi",
	"csi/locale",
	"csi/table/matrix/Path",
	"csi/xml"
], function(declare,_,csi,locale,Path,xml) {

	return declare(Path, {
		bAllowColumnFilter: true,
		columnPath: "Child:SupplierSpecResponseRevs",
		restrictQuery: true,
		selectedColumnValueProperty: "selectedResponses",
		selectedColumnValueDefaultsToAll: false,

		/**
		 * @override
		 * Get response item node for the response
		 */
		_getRowNodes: function(ctx, qr, c, node) {
			const specDataSheetRevNode = ctx.cache.getNode(node.__Parent__);
			return ctx.cache.getNodes(node.ResponseItems).filter(node => node && specDataSheetRevNode && _.contains(specDataSheetRevNode.SupplierSpecResponseRevs, node.__Parent__) && (node.__Parent__ == c.columnUrl));
		},

		/**
		 * @override
		 * Sort the columns based on node name of the SupplierResponse
		 */
		_getColumnNodes: function(ctx, h) {
			let nodes = this.inherited(arguments);
			return csi.sort(nodes, function(node) {
				var refNode = ctx.cache.getNode(node.__Parent__);
				return refNode ? locale.getNodeName(refNode, ctx.cache) : node.__Parent__;
			});
		}

	});
});
